import { Injectable, signal } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

    readonly currentCurrency = signal<string>("SEK");
    subscriptions = new Subscription();
    availableCurrency = [
        { currency: "SEK", description: "Svenska kronor", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "NOK", description: "Norska kronor", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "DKK", description: "Dansk Krone", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "EUR", description: "Euro", symbol: "€", infront: true, space: '' }]; // Example €10
    currentRouteName: string = 'demorino';

    constructor() {
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    getAvailableCurrencies() {
        return this.availableCurrency;
    }

    setCurrency(currencyCode: string) {
        this.currentCurrency.set(currencyCode);
    }

    getCurrency(currencyCode: string) {
        let currencySettings = this.availableCurrency.filter(x => x.currency.toLowerCase() == currencyCode.toLowerCase());

        if (currencySettings.length > 0)
            return currencySettings[0];
        else
            return this.availableCurrency[0];
    }

    fixedDecimalPlaces(value: number) {
        return Number(value.toFixed(2));
    }

}
